import { render, staticRenderFns } from "./cardOrder.vue?vue&type=template&id=6976507d&scoped=true&"
import script from "./cardOrder.vue?vue&type=script&lang=js&"
export * from "./cardOrder.vue?vue&type=script&lang=js&"
import style0 from "./cardOrder.vue?vue&type=style&index=0&id=6976507d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6976507d",
  null
  
)

export default component.exports